import React from 'react';

const StatCard = ({
  title,
  value,
  icon,
  color = 'green',
  miniChart = null,
}) => {
  const colorClasses = {
    green: 'border-brand-green/30',
    red: 'border-severity-critical/30',
    yellow: 'border-severity-medium/30',
    blue: 'border-severity-low/30',
    cyan: 'border-cyan-500/30',
  };

  const textColorClasses = {
    green: 'text-emerald-400',
    red: 'text-red-400',
    yellow: 'text-yellow-400',
    blue: 'text-blue-400',
    cyan: 'text-cyan-400',
  };

  const iconBgClasses = {
    green: 'bg-emerald-500/10 text-emerald-400',
    red: 'bg-red-500/10 text-red-400',
    yellow: 'bg-yellow-500/10 text-yellow-400',
    blue: 'bg-blue-500/10 text-blue-400',
    cyan: 'bg-cyan-500/10 text-cyan-400',
  };

  return (
    <div className={`bg-brand-black-light rounded-lg px-4 py-3 border ${colorClasses[color]} hover:border-opacity-60 transition-all duration-300`}>
      <div className="flex items-center justify-between gap-3">
        {/* Left side - Icon + Title and Value */}
        <div className="flex items-center gap-3 flex-1 min-w-0">
          {/* Icon */}
          {icon && (
            <div className={`p-2 rounded-lg ${iconBgClasses[color]} flex-shrink-0`}>
              {icon}
            </div>
          )}
          {/* Text */}
          <div className="flex-1 min-w-0">
            <div className="text-xs text-gray-500 uppercase tracking-wide mb-0.5 truncate" title={title}>{title}</div>
            <div className={`text-xl font-bold ${textColorClasses[color]} truncate`} title={typeof value === 'number' ? value.toLocaleString() : value}>
              {typeof value === 'number' ? value.toLocaleString() : value}
            </div>
          </div>
        </div>

        {/* Right side - Mini Chart */}
        {miniChart && (
          <div className="w-20 h-8 flex-shrink-0 overflow-hidden">
            {miniChart}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
